import { render } from "./Fiche_Coureur.vue?vue&type=template&id=37ed6c25"
import script from "./Fiche_Coureur.vue?vue&type=script&lang=js"
export * from "./Fiche_Coureur.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__